export enum LanguageEnum {
  ru = 'ru',
  en = 'en',
  de = 'de',
  ptbr = 'pt-br',
  hi = 'hi',
  uk = 'uk',
  az = 'az',
  es = 'es',
  uz = 'uz',
  kk = 'kk',
  bn = 'bn'
}

export type LanguageInfoType = {
  key: LanguageEnum;
  title: string;
  shortName: string;
}

export type LanguageMapType = { [key in LanguageEnum]: LanguageInfoType }
